// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2oXw5","vLegacy":"SelectSecondary_vLegacy__3j91Y","error":"SelectSecondary_error__2l8jt","disabled":"SelectSecondary_disabled__VfKF5"};